<template>
    <el-dialog :visible.sync="show" :title="title" width="800px" :close-on-click-modal="false">

        <!-- 字典类型 -->
        <!-- <el-row :span="24" type="flex" align="middle" class="mt20">
            <el-col :span="4" :offset="2" class="d-flex right required">
                字典类型：
            </el-col>
            <el-col :span="16">
                <el-input :disabled="true" v-model="detail.username" :placeholder="`请输入`"
                    clearable></el-input>
            </el-col>
        </el-row> -->
        <!-- 数据标签 -->
        <el-row :span="24" type="flex" align="middle" class="mt20">
            <el-col :span="4" :offset="2" class="d-flex right required">
                数据标签：
            </el-col>
            <el-col :span="16">
                <el-input :disabled="isView" v-model="detail.name" :placeholder="`请输入`"
                    clearable></el-input>
            </el-col>
        </el-row>
        <!-- 数据键值 -->
        <el-row :span="24" type="flex" align="middle" class="mt20">
            <el-col :span="4" :offset="2" class="d-flex right required">
                数据键值：
            </el-col>
            <el-col :span="16">
                <inputNumber :value.sync="detail.value" :min="0" :step="1" :width="'100%'" :controls="false" :step-strictly="true" :isCenter="false" :placeholder="`请输入`"></inputNumber>
            </el-col>
        </el-row>
        <!-- 显示排序 -->
        <el-row :span="24" type="flex" align="middle" class="mt20">
            <el-col :span="4" :offset="2" class="d-flex right required">
                显示排序：
            </el-col>
            <el-col :span="16">
                <inputNumber :value.sync="detail.order" :min="0" :step="1" :step-strictly="true" :placeholder="`请输入`"></inputNumber>
            </el-col>
        </el-row>
        <!-- 状态 -->
        <!-- <el-row :span="24" type="flex" align="middle" class="mt20">
            <el-col :span="4" :offset="2" class="d-flex right">
                状态：
            </el-col>
            <el-col :span="16">
                <el-radio-group :disabled="isView" v-model="detail.status">
                    <el-radio :label="1">正常</el-radio>
                    <el-radio :label="2">停用</el-radio>
                </el-radio-group>
            </el-col>
        </el-row> -->
        <!-- 备注 -->
        <el-row :span="24" type="flex" align="middle" class="mt20">
            <el-col :span="4" :offset="2" class="d-flex right">
                备注：
            </el-col>
            <el-col :span="16">
                <el-input class="input250" :placeholder="`请输入`" maxLength="10"
                    v-model="detail.remark"></el-input>
            </el-col>
        </el-row>
        <div slot="footer" class="d-flex right">
            <el-button size="small" @click="close">关闭</el-button>
            <el-button v-show="!isView" size="small" type="primary" @click="save">{{ `确定`
                }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import inputNumber from '@/components/form/inputNumber.vue';
import {
    mapGetters
} from 'vuex';
import {
    sysOptionDetailSave,
    sysOptionDetailInfo,
    sysOptionDetailEdit
} from '@/api.js';
export default {
    name: 'DictTypeEdit',
    components: {
        inputNumber
    },
    data() {
        return {
            show: false,
            isView: false,
            detail: {
                id: undefined,
                remark: undefined
            },
        }
    },
    computed: {
        ...mapGetters(['user']),
        mode() {
            // 新建或编辑
            const {
                id
            } = this.detail
            let mode = 'new'; // new or edit
            if (id && Number(id)) {
                mode = 'edit'
            } else {
                mode = 'new'
            }

            return mode
        },
        title() {
            let title = ''
            if (this.mode === 'new') {
                title = `新增`
            } else if (this.mode === 'edit') {
                title = `编辑`
            }

            if (this.isView) {
                title = `详情`
            }

            return title
        },
    },
    created() {
        this.detail.type = (this.$route.params.id || this.$route.params.id == 0) && JSON.parse(this.$route.params.id)
    },
    methods: {
        
        async open(config = {}) {
            this.reset()
            const {
                id,
                isView,
            } = config
            this.isView = !!isView
            if (id && Number(id)) {
                // 编辑时
                const detail = await this.getDictDetail(id)
                this.detail = detail || {}
            } else {
                // 新建时
            }

            this.show = true
        },
        getDictDetail(id) {
            // 获取字典详情
            const url = sysOptionDetailInfo.replace('{id}', id)

            return this.$request('get', url)
        },
        reset() {
            const { type } = this.detail
            this.detail = {
                id: undefined,
                type: type
            },
                this.isView = false
        },
        validateFields(params) {
            // 校验字段
            const {
                name,
                order,
                value,
            } = params

            let msg = '';
            if (!name) {
                msg = `数据标签不能为空`
            } else if (value === undefined || value === '') {
                msg = `数据键值不能为空`
            } else if (order === undefined || order === '') {
                msg = `显示排序不能为空`
            }
            if (msg) {
                this.$message.error(msg)
            }

            return !msg
        },
        save() {

            
            // 保存
            const {
                id,
                name,
                order,
                value,
                remark,
                type
            } = this.detail
            const params = {
                id,
                name,
                order,
                value,
                remark,
                type
            }
            const url = this.mode === 'new' ? sysOptionDetailSave : `${sysOptionDetailEdit}/${id}`

            
            const validate = this.validateFields(params)
            if (!validate) return

            this.$request('post', url, params)
                .then(res => {
                    if (res) {
                        this.$message.success(`操作成功`)
                        this.notifyRefresh()
                        this.close()
                    }
                })
        },
        notifyRefresh() {
            this.$emit('fresh')
        },
        close() {
            this.show = false
        },
    }
}
</script>

<style lang="scss" scoped>
.photo-btn {
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: lightgray;
    border-radius: 4px;
    cursor: pointer;

    i {
        color: #fff;
        font-size: 30px;
        vertical-align: middle;
    }
}

.logo-image {
    height: 60px;
    width: auto;
}

.select-class {
    width: 100%;
}
</style>
<style lang="scss">
.cascader-style {
    height: 30vh;

    .el-cascader-panel {
        height: 100%;
    }
}
</style>